export default __webpack_public_path__ + "static/media/ICONO_PAGO_white.c9bb9eb5.svg";